import { resources } from "@constants/hardcoded-strings";
import {
    AXNUIContent,
    AXNUITheme
} from "@iddataweb/idw-common-ui/types";
import { TabTitleWithErrorCount } from "@containers/common/tab-title-with-error-count/tab-title-with-error-count";
import { ErrorAlert } from "@containers/common/error-alert/error-alert";
import { ThemingActionButtonValidationErrors } from "@idw-types/common/validation/common/theming-validation-errors";

export const getThemingActionButtonValidationErrors = (
    isUsingThemedUI: boolean,
    hasDisplayableDocumentCaptureAttributes: boolean,
    axnuiContent: AXNUIContent,
    axnuiTheme: AXNUITheme
): ThemingActionButtonValidationErrors => {
    let count = 0;
    let customButtonTextError = null;
    let continueOnMobileTextError = null;
    let buttonBorderRadiusError = null;
    if (isUsingThemedUI) {
        if (axnuiTheme.confirmButton.useCustomText && !axnuiContent.confirmButton.buttonText) {
            count += 1;
            customButtonTextError = <ErrorAlert><span>{resources.common.requiredField}</span></ErrorAlert>;
        }
        if (hasDisplayableDocumentCaptureAttributes && !axnuiContent.confirmButton.asyncButtonText) {
            count += 1;
            continueOnMobileTextError = <ErrorAlert><span>{resources.common.requiredField}</span></ErrorAlert>
        }
        if (!axnuiTheme.confirmButton.cornerRadius) {
            count += 1;
            buttonBorderRadiusError = <ErrorAlert><span>This field is required. Please enter a valid Button Border Radius followed by &quot;px&quot;</span></ErrorAlert>;
        } else if (`${axnuiTheme.confirmButton.cornerRadius}`.includes("-")) {
            count += 1;
            buttonBorderRadiusError = <ErrorAlert><span>The Button Border Radius cannot be negative</span></ErrorAlert>;
        } else if (!`${axnuiTheme.confirmButton.cornerRadius}`.includes("px") || `${axnuiTheme.confirmButton.cornerRadius}`.includes(" ")) {
            count += 1;
            buttonBorderRadiusError = <ErrorAlert><span>Please use the format &quot;5px&quot; with no spaces</span></ErrorAlert>;
        } else {
            const numberValue = `${axnuiTheme.confirmButton.cornerRadius}`.split("px")[0];
            if (isNaN(parseInt(numberValue))) {
                count += 1;
                buttonBorderRadiusError = <ErrorAlert><span>Please use the format &quot;5px&quot; with no spaces</span></ErrorAlert>
            }
        }
    }
    return {
        customButtonTextError,
        continueOnMobileTextError,
        buttonBorderRadiusError,
        count: count,
        tabTitle: <TabTitleWithErrorCount
            tabName={resources.pages.verificationServiceDetails.tabs.theming.subTabs.actionButton.tabName}
            errorCount={count}
        />
    };
};